import component from './index';

import less from '!raw-loader!./index.less';
import templateStr from '!raw-loader!./index';

export default {
  component,
  templateStr,
  less,
  dataSource: {
    wrapper: {
      className: 'home-page-wrapper feature24',
      playScale: 0.1,
      always: false,
    },
    page: {
      className: 'home-page feature24-page',
    },
    bg: {
      className: 'feature24-bg',
      children: 'https://imm.86links.com/assets/landing/feature/feature24_3.png',
    },
    content: {
      className: 'feature24-content',
      box: {
        className: 'feature24-content-box',
        children: [
          {
            name: '大标题',
            className: 'feature24-content-box-title',
            children: '大标题',
          },
          {
            name: '小标题',
            className: 'feature24-content-box-hint',
            children: '小标题',
          },
          {
            name: '内容',
            className: 'feature24-content-box-text',
            children:
              '聚集"汽车+"新经济、"赛事+"新经济、智能制造、文化创意、汽车贸易博览、大健康等高新技术、创新型企业500余家。',
          },
        ],
      },
      images: {
        className: 'feature24-content-image',
        children: [
          {
            name: '图片0',
            className: 'feature24-content-image-item',
            children:
              'https://imm.86links.com/assets/landing/feature/feature24_1.png',
          },
          {
            name: '图片1',
            className: 'feature24-content-image-item',
            children:
              'https://imm.86links.com/assets/landing/feature/feature24_2.png',
          },
        ],
      },
    },
  },
};
